// import './DashLiteTheme.css';
import './GlobalStyles.css';

const GlobalStyles = ({ children }) => {
    return children;
}

export default GlobalStyles;
